import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';
import { VideoModel } from '../../../../../shared/components/video-recorder/video-model';
import { MediaService } from '../../../../../shared/services/media.service';
import { Answer } from '../../../../applicant-service/service-models/Answer';
import { VideoQuestion } from '../../../../job-service/service-models/VideoQuestion';
import { QuestionComponent } from '../question-component';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent extends QuestionComponent<VideoQuestion> implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();

  @ViewChild('removeModal') removeModal: ModalDirective;
  @ViewChild('questionElement') questionElement: ElementRef;
  @ViewChild('videoElement') videoElement: any;
  downloadRoute: string;
  applicantId: string;
  scopeKey = 'applicant-element.question';
  mediaId: number;
  video;
  videoUrl;

  downloading = false;
  downloadError = false;
  uploading = false;
  uploadError = false;
  retryAttempt = 0;

  constructor(
    private route: ActivatedRoute,
    private mediaService: MediaService,
    private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    this.subscription.add(this.route.parent.params.subscribe((params: Params) => {
      this.applicantId = params['applicantId'];
      this.downloadRoute = `jobs/${this.jobId}/elements/${this.element.id}/questions/${this.question.id}/attachments`;
      this.question = this.question || new VideoQuestion();

      if (
        this.question.answers === undefined
        || this.question.answers.length === 0
        || (this.question.answers.length > 0
          && !this.question.answers[0].value)) {
        this.initialzeAnswers();
      } else {
        this.mediaId = +this.question.answers[0].value;
        this.question.isValid = true;
        this.downloadVideo();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  setVideoData(video: VideoModel) {
    this.uploadError = false;
    this.video = video.videoBlob;
    this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(video.videoBlob.url);

    this.retryAttempt = 0;
    this.uploading = true;
    this.uploadError = false;
    this.uploadVideo(video);
  }

  uploadVideo(video: VideoModel) {
    const videoFile = new File([video.videoBlob.blob], video.videoBlob.title, { type: 'video/mp4' });
    this.subscription.add(this.mediaService.uploadVideo(this.applicantId, this.scopeKey, video.duration.seconds(), videoFile)
      .subscribe(data => {
        this.mediaId = +data.headers.get('location');
        const answer = this.question.answers[0];
        answer.questionId = this.question.id;
        answer.questionVersion = this.question.version;
        answer.value = this.mediaId.toString();
        this.question.isValid = true;
        this.uploading = false;
        this.questionAnswered();

        this.enableVideoControls();
      },
      error => {
        if (this.retryAttempt < 3) {
          this.retryAttempt++;
          this.uploadVideo(video);
        } else {
          console.log(error);
          this.uploadError = true;
          this.uploading = false;
          this.removeVideo();
        }
      }));
  }

  openRemoveVideoModal() {
    this.removeModal.show();
  }

  removeVideo() {
    this.video = null;
    this.videoUrl = null;
    this.mediaId = null;
    this.downloadError = false;
    this.initialzeAnswers();
    this.questionAnswered();
    this.removeModal.hide();
  }

  downloadVideo() {
    this.downloading = true;
    this.downloadError = false;

    this.subscription.add(
      this.mediaService.downloadVideo(this.applicantId, this.mediaId)
        .subscribe(response => {
          const blob = new Blob([response]);
          this.video = new File(
            [blob],
            'answer.mp4',
            { type: 'video/mp4' }
          );

          const url = window.URL || window.webkitURL;
          this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(url.createObjectURL(this.video));

          this.enableVideoControls();
          this.downloading = false;
        },
        error => {
          this.downloading = false;
          this.downloadError = true;
        }));
  }

  private initialzeAnswers() {
    const answer = new Answer();
    answer.questionId = this.question.id;
    answer.questionVersion = this.question.version;
    this.question.answers = [answer];
    this.question.isValid = false;
  }

  private enableVideoControls() {
    const context = this;
    setTimeout(() => {
      context.videoElement.nativeElement.controls = true;
    }, 0);
  }

}
